import http from '../../services/http-common';
import { 
  PdfGrid, PdfPen, PdfBitmap, PdfBrushes, PdfDocument, PdfBorders, PdfPage, 
  PdfColor, PdfSolidBrush, PdfFontStyle, PdfPageSize, PdfPageOrientation, 
  PdfAlignmentStyle, PdfStringFormat, PdfTextAlignment, PdfStandardFont, PointF,PdfVerticalAlignment,PdfPaddings,
  PdfFontFamily ,PdfMargins,PdfLayoutType,PdfLayoutFormat,PdfWordWrapType
} from "@syncfusion/ej2-pdf-export"; 
import moment from 'moment';


class SaleInvoiceServicePreivewG {

    wrapText(graphics, text, font, brush, x, y, maxWidth, lineHeight) {
        const words = String(text ?? "").split(" ");
        let line = "";
        let yOffset = y;
      
        for (let i = 0; i < words.length; i++) {
          const testLine = line + words[i] + " ";
          const testWidth = font.measureString(testLine).width;
      
          if (testWidth > maxWidth && i > 0) {
            graphics.drawString(line.trim(), font, null, brush, x, yOffset);
            line = words[i] + " ";
            yOffset += lineHeight;
          } else {
            line = testLine;
          }
        }
      
        if (line) {
          graphics.drawString(line.trim(), font, null, brush, x, yOffset);
        }
      
        // IMPORTANT: return last drawn Y so caller can continue below it
        return yOffset;
      }
      
      async SalesTaxInvoiceReport   (invoiceDetails, invoiceItems,blob, type = 'download') {
        const document = new PdfDocument();
      
        // Page settings
        document.pageSettings.margins.all = 10;
        document.pageSettings.margins.bottom = 5;
        document.pageSettings.size = PdfPageSize.a4;
      
        // Add page
        const page = document.pages.add();
        let graphics = page.graphics;
      
        // Fonts & brushes
        const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 16, PdfFontStyle.Bold);
        const subFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
        const subBoldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8, PdfFontStyle.Bold);
        const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
        const boldFonts = new PdfStandardFont(PdfFontFamily.Helvetica, 10, PdfFontStyle.Bold);
        
        const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
        const pageWidth = page.getClientSize().width;
        // ===== Header =====
        if(invoiceDetails.sellerLogo && invoiceDetails.sellerLogo    != ''){
        const logoBytes =invoiceDetails.sellerLogo
        
        //  // ===== IMAGE (Base64 PNG) =====
        const blobToBase641 = (blob) => {
          return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
              reader.onerror = reject;
              reader.readAsDataURL(blob);
          });
        };
      
      
    
          const url1 = URL.createObjectURL(logoBytes);
    
          const response1 = await fetch(url1);
          if (!response1.ok) throw new Error(`Failed to fetch image: ${response1.statusText}`);
        
          const imageBlob1 = await response1.blob();
          const imageBase641 = await blobToBase641(imageBlob1);
        
         // Create PdfBitmap from Base64
         
             

  const imageBase64s = new PdfBitmap(imageBase641);


  // Get original dimensions
  const originalWidth = imageBase64s.width;
  const originalHeight = imageBase64s.height;
  
  // Max allowed size
  const maxWidth = 110;
  const maxHeight = 110;
  
  // Calculate scale ratio
  const widthRatio = maxWidth / originalWidth;
  const heightRatio = maxHeight / originalHeight;
  const scale = Math.min(widthRatio, heightRatio);
  
  // New scaled size
  const newWidth = originalWidth * scale;
  const newHeight = originalHeight * scale;
  
  // Draw image centered (optional)
  const x = 10;
  const y = 10;
  
  graphics.drawImage(imageBase64s, x, y, newWidth, newHeight)
    
      // graphics.drawImage(imageBase64s, 10, 10, 60, 60);
    
    
    
        }
    
    
    
    
    
    
    
        // Create PdfBitmap from Base64
      // if(invoiceDetails.sellerLogo){
        //  // ===== IMAGE (Base64 PNG) =====
        
          // const response = await fetch(url);
          // if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
        
          // const imageBlob = await response.blob();
          // const imageBase64 = await blobToBase64(invoiceDetails.sellerLogo);
          // const imageBase64 = ;
        //   console.log(imageBase64)
        // const imageD = new PdfBitmap(invoiceDetails.sellerLogo);
           
        // // Draw the image on the PDF
        // let xImgPos = page.getClientSize().width - 115;  // right aligned box
        //  let yImgPos =  170; 
        //  graphics.drawImage(imageD, 10, 140,96 ,96 ); // Adjust x, y, width, height as needed
      // }
    
        graphics.drawString("Sales Tax Invoice", headerFont, null, blackBrush, 220, 30);

    graphics.drawString("SOFTWARE  ID:", boldFont, null, blackBrush, 350, 120 - 16);
    graphics.drawString(`${String(invoiceDetails.SaleInvoiceID).padStart(4, '0')}`, subFont, null, blackBrush, 440, 120-16+1);
    graphics.drawString("DATE:", boldFont, null, blackBrush, 350, 120);
    graphics.drawString(`${moment(invoiceDetails.date).format("DD-MMM-YY")}`, subFont, null, blackBrush, 440, 121);
  
        // // ===== Buyer Info =====
        // graphics.drawString("INVOICE:", boldFont, null, blackBrush, 10, 35);
        // graphics.drawString(`${(invoiceDetails.invoiceNo).toUpperCase()}`, subFont, null, blackBrush, 55, 36);
    
        // graphics.drawString("BUYER:", boldFont, null, blackBrush, 10, 65);
        // // graphics.drawString(invoiceDetails.buyerName.toUpperCase(), subFont, null, blackBrush, 10, 85);
        //  this.wrapText(graphics,invoiceDetails.buyerName.toUpperCase(), subFont, blackBrush, 10, 80, 280, 10);
        // //  this.wrapText(graphics,'National Absorbent Cotton Mills Co TEXTILE'.toUpperCase(), subFont, blackBrush, 10, 80, 280, 10);
        
        
        // // graphics.drawString(invoiceDetails.sellerAddress, subFont, null, blackBrush, 400, 105);
        // this.wrapText(graphics, invoiceDetails.buyerAddress.toUpperCase(), subFont, blackBrush, 10, 90, 270, 10);
        // // this.wrapText(graphics, 'National Absorbent Cotton Mills Co INTERNATIONAL TEXTILE National Absorbent Cotton Mills Co INTERNATIONAL TEXTILE'.toUpperCase(), subFont, blackBrush, 10, 90, 270, 10);
        
        
        // graphics.drawString(`REGION:`, boldFont, null, blackBrush, 10, 115);
        // graphics.drawString(`${(invoiceDetails.buyerRegion).toUpperCase()}`, subFont, null, blackBrush, 50, 116);
        
        // graphics.drawString(`NTN:`, boldFont, null, blackBrush, 10, 130);
    
        // graphics.drawString(`${invoiceDetails.buyerNTN.toUpperCase()}`, subFont, null, blackBrush, 35, 131);
        
        // graphics.drawString(`TYPE:`, boldFont, null, blackBrush, 10, 145);
    
        // graphics.drawString(`${invoiceDetails.buyerType.toUpperCase()}`, subFont, null, blackBrush, 40, 146);
        
        // graphics.drawString(`SALE TYPE:`, boldFont, null, blackBrush, 10, 160);
    
        // graphics.drawString(`${invoiceDetails.saleType ? invoiceDetails.saleType.toUpperCase() : ''}`, subFont, null, blackBrush, 68, 161);
      
        // // ===== Seller Info =====
        // graphics.drawString("SELLER:", boldFont, null, blackBrush, 350, 65);
        // // graphics.drawString(invoiceDetails.sellerName, subFont, null, blackBrush, 400, 90);
        // this.wrapText(graphics, invoiceDetails.sellerName, subFont, blackBrush, 350, 80, 200, 10);
        
        // // graphics.drawString(invoiceDetails.sellerAddress, subFont, null, blackBrush, 400, 105);
        // this.wrapText(graphics, invoiceDetails.sellerAddress, subFont, blackBrush, 350, 90, 200, 10);
        
    
        // graphics.drawString(`REGION:`, boldFont, null, blackBrush, 350, 115);
        // graphics.drawString(`${(invoiceDetails.sellerRegion).toUpperCase()}`, subFont, null, blackBrush, 390, 116);
        
        // graphics.drawString(`NTN:`, boldFont, null, blackBrush, 350, 130);
        // graphics.drawString(`${invoiceDetails.sellerNTN.toUpperCase()}`, subFont, null, blackBrush, 3120, 131);
        
    
    
        //  graphics.drawString(`TYPE:`, boldFont, null, blackBrush, 350, 145);
    
        // graphics.drawString(`REGISTERED`, subFont, null, blackBrush, 380, 146);
    
    
        // ---------- helpers ----------
    // const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";
    
const lineH10 = 10;     // for wrap text
const rowGap = 15;      // standard row vertical gap

const buyerX = 10;
const sellerX = 350;

const buyerLabelX = buyerX;
const sellerLabelX = sellerX;

// fixed indent so values align nicely
const buyerValueX = buyerX + 90;
const sellerValueX = sellerX + 90;

// available widths for wrapped values
const buyerValueWidth = 280 - 90; // block width ~280, minus indent
const sellerValueWidth = 200 - 90; // block width ~200, minus indent

const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";

const drawOptionalRowPair = (y, caption, buyerVal, sellerVal) => {
  // Row show ONLY if either side has value
  if (!hasValue(buyerVal) && !hasValue(sellerVal)) return y;

  // captions on BOTH sides
  graphics.drawString(`${caption}:`, boldFont, null, blackBrush, buyerLabelX, y);
  graphics.drawString(`${caption}:`, boldFont, null, blackBrush, sellerLabelX, y);

  // values (only where present)
  const buyerEndY = hasValue(buyerVal)
    ? this.wrapText(graphics, String(buyerVal), subFont, blackBrush, buyerValueX, y + 1, buyerValueWidth, lineH10)
    : y;

  const sellerEndY = hasValue(sellerVal)
    ? this.wrapText(graphics, String(sellerVal), subFont, blackBrush, sellerValueX, y + 1, sellerValueWidth, lineH10)
    : y;

  // next row starts after the longer (wrapped) side
  return Math.max(buyerEndY, sellerEndY) + rowGap;
};

// ---------- Reference No. above INVOICE ----------

// ---------- TOP LEFT BLOCK ----------
let leftTopY = 125; // moved down from 80

if (hasValue(invoiceDetails?.OrderReferenceNo)) {
  graphics.drawString(
    (`${localStorage.getItem("SaleInvoiceOrderReferenceNoCaption") || 'ORDER Reference No'}:`).toUpperCase(),
    boldFont,
    null,
    blackBrush,
    buyerLabelX,
    leftTopY - 16
  );

  this.wrapText(
    graphics,
    String(invoiceDetails.OrderReferenceNo || '').toUpperCase(),
    subFont,
    blackBrush,
    buyerLabelX + 90,
    leftTopY - 15,
    buyerValueWidth,
    lineH10
  );
}

if (hasValue(invoiceDetails?.ChallanNo)) {
  graphics.drawString(
    (`${localStorage.getItem("SaleInvoiceChallanNoCaption") || "REFERENCE NO."}:`).toUpperCase(),
    boldFont,
    null,
    blackBrush,
    buyerLabelX,
    leftTopY
  );

  this.wrapText(
    graphics,
    String(invoiceDetails.ChallanNo || '').toUpperCase(),
    subFont,
    blackBrush,
    buyerLabelX + 90,
    leftTopY + 1,
    buyerValueWidth,
    lineH10
  );
}

// ---------- INVOICE ----------
graphics.drawString("FBR INVOICE NO.:", boldFont, null, blackBrush, 10, leftTopY + 15);

graphics.drawString(
  `${String(invoiceDetails.invoiceNo ?? "").toUpperCase()}`,
  subFont,
  null,
  blackBrush,
  100,
  leftTopY + 16
);

// ---------- BUYER block ----------
graphics.drawString("BUYER:", boldFont, null, blackBrush, buyerLabelX, leftTopY + 40);

let buyerY = 185;
buyerY = this.wrapText(
  graphics,
  String(invoiceDetails?.buyerName ?? "").toUpperCase(),
  // subFont,
  subBoldFont,
  blackBrush,
  buyerLabelX,
  buyerY,
  280,
  lineH10
) + lineH10;

buyerY = this.wrapText(
  graphics,
  String(invoiceDetails?.buyerAddress ?? "").toUpperCase(),
  subFont,
  blackBrush,
  buyerLabelX,
  buyerY,
  270,
  lineH10
) + rowGap;

// // Optional rows BEFORE REGION
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "Contact Person", invoiceDetails?.buyerContactPerson, buyerValueWidth);
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "Contact No.",     invoiceDetails?.buyerContactNumber, buyerValueWidth);
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "STRN",            invoiceDetails?.buyerSTRN, buyerValueWidth);
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "CNIC No.",        invoiceDetails?.buyerCNIC, buyerValueWidth);

// ---------- SELLER block ----------
graphics.drawString("SELLER:", boldFont, null, blackBrush, sellerLabelX, 160);

let sellerY = 180;
sellerY = this.wrapText(
  graphics,
  String(invoiceDetails?.sellerName ?? "").toUpperCase(),
  // subFont,
  subBoldFont,
  blackBrush,
  sellerLabelX,
  sellerY,
  200,
  lineH10
) + lineH10;

sellerY = this.wrapText(
  graphics,
  String(invoiceDetails?.sellerAddress ?? "").toUpperCase(),
  subFont,
  blackBrush,
  sellerLabelX,
  sellerY,
  200,
  lineH10
) + rowGap;

// // Optional rows BEFORE REGION
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "Contact Person", invoiceDetails?.sellerContactPerson, sellerValueWidth);
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "Contact No.",     invoiceDetails?.sellerContactNumber, sellerValueWidth);
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "STRN",            invoiceDetails?.sellerSTRN, sellerValueWidth);
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "CNIC No.",        invoiceDetails?.sellerCNIC, sellerValueWidth);

// ---------- Align REGION/NTN/TYPE/SALE TYPE to the lower of both sides ----------
// let commonY = Math.max(buyerY, sellerY);
// buyerY = commonY;
// sellerY = commonY;
// After buyerAddress + sellerAddress blocks (jab buyerY & sellerY ready hon)
let commonY = Math.max(buyerY, sellerY);
buyerY = sellerY = commonY;

// Optional rows (row-level OR)
commonY = drawOptionalRowPair(
  commonY,
  "CONTACT PERSON",
  invoiceDetails?.buyerContactPerson,
  invoiceDetails?.sellerContactPerson
);

commonY = drawOptionalRowPair(
  commonY,
  "CONTACT NO.",
  invoiceDetails?.buyerContactNumber,
  invoiceDetails?.sellerContactNumber
);

commonY = drawOptionalRowPair(
  commonY,
  "STRN",
  invoiceDetails?.buyerSTRN,
  invoiceDetails?.sellerSTRN
);

commonY = drawOptionalRowPair(
  commonY,
  "CNIC NO.",
  invoiceDetails?.buyerCNIC,
  invoiceDetails?.sellerCNIC
);

buyerY = sellerY = commonY; // keep both aligned for REGION/NTN/TYPE etc

// BUYER mandatory rows
graphics.drawString("REGION:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.buyerRegion ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

graphics.drawString("NTN:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.buyerNTN ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

graphics.drawString("TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.buyerType ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

graphics.drawString("SALE TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.saleType ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

// SELLER mandatory rows
graphics.drawString("REGION:", boldFont, null, blackBrush, sellerLabelX, sellerY);
graphics.drawString(String(invoiceDetails?.sellerRegion ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
sellerY += rowGap;

graphics.drawString("NTN:", boldFont, null, blackBrush, sellerLabelX, sellerY);
// graphics.drawString(String(invoiceDetails?.sellerNTN ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
graphics.drawString(String(
  invoiceDetails?.sellerNTNCNICReferenceNo &&
  invoiceDetails.sellerNTNCNICReferenceNo.length >= 7
    ? invoiceDetails.sellerNTNCNICReferenceNo
    : invoiceDetails?.sellerNTN ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
sellerY += rowGap;

graphics.drawString("TYPE:", boldFont, null, blackBrush, sellerLabelX, sellerY);
graphics.drawString("REGISTERED", subFont, null, blackBrush, sellerValueX, sellerY + 1);
sellerY += rowGap;

// ---------- Use this to place table automatically below header blocks ----------
const tableStartY = Math.max(180, Math.max(buyerY, sellerY) + 5);
const pdfGrid = new PdfGrid();
    // graphics.drawString(`Type:`, boldFont, null, blackBrush, 350, 155);
    // graphics.drawString(`${invoiceDetails.sellerType}`, subFont, null, blackBrush, 380, 155);
  
    // ===== Table =====
//     const pdfGrid = new PdfGrid();
//     pdfGrid.columns.add(13);
//   // Set column widths
// pdfGrid.columns.getColumn(0).width = 25;   // SR No.
// pdfGrid.columns.getColumn(1).width = 50;   // SR No.
// pdfGrid.columns.getColumn(2).width = 55;  // Description
// pdfGrid.columns.getColumn(3).width = 45;   // HS Code
// pdfGrid.columns.getColumn(4).width = 45;   // Quantity
// pdfGrid.columns.getColumn(5).width = 35;   // Rate
// pdfGrid.columns.getColumn(6).width = 65;   // Amount
// pdfGrid.columns.getColumn(7).width = 35;   // Sales Tax
// pdfGrid.columns.getColumn(8).width = 35;   // Extra Tax
// pdfGrid.columns.getColumn(9).width = 40;   // Further Tax
// pdfGrid.columns.getColumn(10).width = 40;   // FED
// pdfGrid.columns.getColumn(11).width = 45;  // Discount
// pdfGrid.columns.getColumn(12).width = 60;  // Total

//     // Header row
//     const header = pdfGrid.headers.add(1)[0];
//     const headers = [
//       "SR No.","Invoice Number (Detail)", "Document Description", "HS Code", "Quantity", "Rate", "Value of Sales Excl ST",
//       "Sales Tax", "Extra Tax", "Further Tax", "FED Payable", "Discount", "Total Value"
//     ];
//     // headers.forEach((h, i) => {
//     //   header.cells.getCell(i).value = h;
//     //   header.cells.getCell(i).style.font = boldFont;
//     // });

//     const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
//     headers.forEach((h, i) => { 
//       header.cells.getCell(i).value = h;
//       header.cells.getCell(i).style.font = headersboldFont;
//       header.cells.getCell(i).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
    
//       // Apply header background + font color
//       header.cells.getCell(i).style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 102, 128)); // teal blue
//       header.cells.getCell(i).style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));    // white text
//     });
  
//     // Data rows
//     invoiceItems.forEach((item,i) => {
//       const row = pdfGrid.rows.addRow();
//       row.cells.getCell(0).value = item.srNo.toString();
//       row.cells.getCell(1).value = item.FBRSaleInvoiceDetailNo;
//       row.cells.getCell(2).value = item.description;
//       row.cells.getCell(3).value = item.hsCode;
//       // row.cells.getCell(4).value = item.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(4).value =
//   `${item.quantity.toLocaleString('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//   })}\n${item.uoM}`;
//       row.cells.getCell(5).value = item.rate;
//       row.cells.getCell(6).value = item.amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });;
//       row.cells.getCell(7).value = item.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(8).value = item.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(9).value = item.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(10).value = item.fed.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(11).value = item.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(12).value = item.totalInclTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      
//       for (let c = 0; c < row.cells.count; c++) {
//         row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
//       }
//     });
  
//     pdfGrid.style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

//     pdfGrid.style.cellPadding.all = 3;
//     // pdfGrid.draw(page, { x: 0, y: 180 });
//     const layoutResult = pdfGrid.draw(page, { x: 0, y: 180 });
 
// const pdfGrid = new PdfGrid();

const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
const bodyFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

// Reusable header style function
const styleHeaderCell = (cell) => {
  cell.style.font = headersboldFont;
  cell.style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
  cell.style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 102, 128)); // teal blue
  cell.style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));     // white text
};

// ----------------------------
// CASE A: 3rd Schedule Goods
// 11 columns (remove ExtraTax, FED, Discount; add Fixed/Notified)
// Column order keeps your structure and places NEW column where ExtraTax was
// ----------------------------

const PAGE_PADDING = 0;
    // const pageWidth = page.getClientSize().width;
    const usableWidth = pageWidth - PAGE_PADDING * 2;
    const thirdScheduleColumns = [
      { key: "srNo", label: "Sr No.", min: 18 },
      { key: "FBRSaleInvoiceDetailNo", label: "Invoice Number (Detail)", min: 70 },
      { key: "description", label: "Document Description", min: 105 },
      // { key: "SaleProductDescription", label: "Sale Product Description", min: 50 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: "SaleQuantity", label: "Sale Quantity", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: "SaleRate", label: "Sale Rate", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      // { key: "SaleUnitOfMeasurement", label: "Sale UOM", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: "hsCode", label: "HS Code", min: 40 },
      { key: "quantity", label: "Quantity", min: 35 },
      { key: "rate", label: "Rate", min: 22 },
      { key: "amount", label: "Value of Sales Excl ST", min: 45, visible: invoiceDetails.amountIsVisible },
      { key: "salesTax", label: "Sales Tax", min: 35, visible: invoiceDetails.salesTaxsVisible },
      {
        key: "fixedNotifiedValueOrRetailPrice",
        label: "FIXED / NOTIFIED VALUE OR RETAIL PRICE",
        min: 55,
        visible: invoiceDetails.fixedNotifiedValueOrRetailPrice !== 0
      },
      { key: "furtherTax", label: "Further Tax", min: 42, visible: invoiceDetails.furtherTaxsVisible },
      { key: "totalInclTax", label: "Total Value", min: 50, visible: invoiceDetails.totalInclTaxsVisible }
    ];
    
    const normalColumns = [
      { key: "srNo", label: "Sr No.", min: 18 },
      { key: "FBRSaleInvoiceDetailNo", label: "Invoice Number (Detail)", min: 70 },
      { key: "description", label: "Document Description", min: 105 },
      // { key: "SaleProductDescription", label: "Sale Product Description", min: 55 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: "SaleQuantity", label: "Sale Quantity", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: "SaleRate", label: "Sale Rate", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      // { key: "SaleUnitOfMeasurement", label: "Sale UOM", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: "hsCode", label: "HS Code", min: 40 },
      { key: "quantity", label: "Quantity", min: 45 },
      { key: "rate", label: "Rate", min: 22 },
      { key: "amount", label: "Value of Sales Excl ST", min: 45, visible: invoiceDetails.amountIsVisible },
      { key: "salesTax", label: "Sales Tax", min: 45, visible: invoiceDetails.salesTaxsVisible },
      { key: "extraTax", label: "Extra Tax", min: 35, visible: invoiceDetails.extraTaxsVisible },
      { key: "furtherTax", label: "Further Tax", min: 35, visible: invoiceDetails.furtherTaxsVisible },
      { key: "fed", label: "FED Payable", min: 35, visible: invoiceDetails.fedsVisible },
      { key: "discount", label: "Discount", min: 35, visible: invoiceDetails.discountsVisible },
      { key: "totalInclTax", label: "Total Value", min: 50, visible: invoiceDetails.totalInclTaxsVisible }
    ];
    
    
    const saleTypeNormalized = String(invoiceDetails?.saleType ?? "")
      .replace(/\s+/g, "")     // remove ALL spaces
      .toLowerCase();
    
    const isThirdScheduleGoods = saleTypeNormalized === "3rdschedulegoods";
    
    const baseColumns = isThirdScheduleGoods ? thirdScheduleColumns : normalColumns;
    // const baseColumns =  thirdScheduleColumns;
    
    const visibleColumns = baseColumns.filter(
      c => c.visible !== false // default = visible
    );
    
    // const totalMinWidth = visibleColumns.reduce((s, c) => s + c.min, 0);
    // const scale = usableWidth / totalMinWidth;
    
    // visibleColumns.forEach(c => {
    //   c.width = Math.max(c.min * scale, c.min);
    // });
    
    const totalMinWidth = visibleColumns.reduce(
      (sum, col) => sum + col.min,
      0
    );
    
    // STEP 3
    // Remaining width after minimum widths
    const remainingWidth = usableWidth - totalMinWidth;
    
    // STEP 4
    // Extra width equally divide
    const extraWidthPerColumn =
      remainingWidth > 0
        ? remainingWidth / visibleColumns.length
        : 0;
    
    // STEP 5
    // Final width assign
    visibleColumns.forEach(col => {
      col.width = col.min + extraWidthPerColumn;
    });
    
    
    pdfGrid.columns.add(visibleColumns.length);
    
    visibleColumns.forEach((col, i) => {
      pdfGrid.columns.getColumn(i).width = col.width;
    });
    
    
    
    
    
    
    
    const header = pdfGrid.headers.add(1)[0];
    
    visibleColumns.forEach((col, i) => {
      const cell = header.cells.getCell(i);
      cell.value = col.label;
      styleHeaderCell(cell);
    });
    
    
    
    
    
    invoiceItems.forEach(item => {
      const row = pdfGrid.rows.addRow();
    
      visibleColumns.forEach((col, i) => {
        let value = item[col.key] ?? "";
    
        if (["amount", "salesTax", "extraTax", "furtherTax", "fed", "discount", "totalInclTax"].includes(col.key)) {
          value = Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 ,maximumFractionDigits: 2 });
        }
    
        if (col.key === "quantity") {
          value = `${Number(item.quantity ?? 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,maximumFractionDigits: 2
          })}\n${String(item.uoM ?? "").toUpperCase()}`;
        }
    
        row.cells.getCell(i).value = String(value);
        row.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
      });
    });
    
    
    
    
    
    // shared styling
    pdfGrid.style.font = bodyFont;
    pdfGrid.style.cellPadding.all = 3;
    
    // draw
    // const layoutResult = pdfGrid.draw(page, { x: 0, y: 180 });
    
    
    
    
// Draw grid
const layoutFormat = new PdfLayoutFormat();
layoutFormat.layout = PdfLayoutType.Paginate;

// const layoutResult = pdfGrid.draw(page, { x: 0, y: tableStartY },layoutFormat);

// const lastPage = layoutResult.page;
// const lastBounds = layoutResult.bounds;
// let currentY = layoutResult.bounds.y + layoutResult.bounds.height + 20;

//  graphics = lastPage.graphics;

const layoutResult = pdfGrid.draw(page, { x: 0, y: tableStartY }, layoutFormat);

let currentPage = layoutResult.page;
 graphics = currentPage.graphics;

let currentY = layoutResult.bounds.y + layoutResult.bounds.height + 20;


const pageHeight = currentPage.getClientSize().height;

if (currentY + 180 > pageHeight) {
  currentPage = document.pages.add();
  graphics = currentPage.graphics;
  currentY = 20;
}
// Remarks
// let remarksY = lastBounds.y + lastBounds.height + 20;

    // const layoutResult = pdfGrid.draw(page, { x: 0, y: tableStartY });
    
    
        // ===== Totals =====
        console.log('layout result',layoutResult)
        let CalculateGap = invoiceItems?.length * 20
        // let yBase = 310 + CalculateGap;
        // let yBase = lastBounds.y + lastBounds.height + 25;
    
        // After drawing PdfGrid
    
    
    
    //     let xPos = page.getClientSize().width - 250;  // right aligned box
    // let yPos = lastBounds.height + lastBounds.y + 20; 
    let xPos = currentPage.getClientSize().width - 250;
let yPos = currentY;

    let boxWidth = 220;
    let boxHeight = 140;
    
    graphics.drawRectangle(new PdfPen(PdfColor.black, 1), xPos, yPos, boxWidth, boxHeight);
    
    let lineHeight = 14;
    let padding = 5;
    currentY += 110; // box ke baad niche shift
    // Function to measure and right-align text
    function drawRightAligned(text, yOffset, font) {
        let textWidth = font.measureString(text).width;
        let drawX = xPos + boxWidth - padding - textWidth; // right edge inside box
        let drawY = yPos + yOffset;
        graphics.drawString(text, font, null, PdfBrushes.black, drawX, drawY);
    }
    if(isThirdScheduleGoods){
      drawRightAligned(`Value of Sales Excl ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
      drawRightAligned(`FIXED/NOTIFIED VALUE OR RETAIL PRICE: ${invoiceDetails.fixedNotifiedValueOrRetailPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
      drawRightAligned(`Sales Tax (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
      drawRightAligned(`Further Tax: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 3, subFont);
      if(invoiceDetails.ShowAdvanceIncomeTax  == true){
        drawRightAligned(`Advance Tax U/S  ${invoiceDetails.AdvanceIncomeTaxDescription} @${invoiceDetails.AdvanceIncomeTaxPercent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% : ${invoiceDetails.TotalAdvanceIncomeTaxAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 6, subFont);
      }
    }
    else{
    drawRightAligned(`Value of Sales Excl ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
    drawRightAligned(`Sales Tax (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
    drawRightAligned(`Further Tax: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
    drawRightAligned(`Extra Tax: ${invoiceDetails.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 3, subFont);
    drawRightAligned(`FED Payable: ${invoiceDetails.fedPayable.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 4, subFont);
    drawRightAligned(`Discount: ${invoiceDetails.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 5, subFont);
    if(invoiceDetails.ShowAdvanceIncomeTax  == true){
    drawRightAligned(`Advance Tax U/S  ${invoiceDetails.AdvanceIncomeTaxDescription} @${invoiceDetails.AdvanceIncomeTaxPercent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% : ${invoiceDetails.TotalAdvanceIncomeTaxAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 6, subFont);
    }
    }
    drawRightAligned(
      `Grand Total Value : Rs. ${invoiceDetails.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      9 + lineHeight * 7,
      boldFont
    );
    
        // ===== Amount in Words =====
        // graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
        // graphics.drawString(invoiceDetails.grandTotalInWords, boldFont, null, blackBrush, 10, yBase + 15);
      
        // graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
        // this.wrapText(graphics, invoiceDetails.grandTotalInWords, boldFont, blackBrush, 10, yBase + 15, 300, 15);
        
    
        graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yPos);

        this.wrapText(
          graphics,
          String(invoiceDetails?.grandTotalInWords ?? ""),
          boldFont,
          blackBrush,
          10,
          yPos + 15,
          300,
          15
        );
        
        currentY += 50;

        if (currentY + 120 > pageHeight) {
  currentPage = document.pages.add();
  graphics = currentPage.graphics;
  currentY = 20;
}
        
    
        //  // ===== IMAGE (Base64 PNG) =====
        const blobToBase64 = (blob) => {
          return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
              reader.onerror = reject;
              reader.readAsDataURL(blob);
          });
        };
      
      
    
          const url = URL.createObjectURL(blob);
    
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
        
          const imageBlob = await response.blob();
          const imageBase64 = await blobToBase64(imageBlob);
        
         // Create PdfBitmap from Base64
         const image = new PdfBitmap(imageBase64);
           
         // Draw the image on the PDF
        //  let xImgPos = page.getClientSize().width - 115;  // right aligned box
        //   let yImgPos = lastBounds.height + lastBounds.y + 170; 
          let xImgPos = currentPage.getClientSize().width;

         graphics.drawImage(image, xImgPos - 115, currentY,96 ,96 ); // Adjust x, y, width, height as needed
          
    
    
         // ==== FBR IMAGE DRAW ====
         const FBRIMGresponse = await fetch('/fbr-img.jpg');
         if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
         
                 const FBRimageBlob = await FBRIMGresponse.blob();
                 const FBRimageBase64 = await blobToBase64(FBRimageBlob);
         
                // Create PdfBitmap from Base64
                const FBRimage = new PdfBitmap(FBRimageBase64);
                  
                // Draw the FBRimage on the PDF
                graphics.drawImage(FBRimage, 40, currentY,50 ,50 ); // Adjust x, y, width, height as needed

                currentY += 110;
                graphics.drawString(
                    "THIS IS A SYSTEM GENERATED DIGITAL INVOICE. NO SIGNATURE REQUIRED",
                    subFont,
                    null,
                    blackBrush,
                    pageWidth / 2 - 150,
                    currentY
                  );
                  currentY += 20;

                  // graphics.drawString(
                  //   invoiceDetails.SellerRemarks,
                  //   boldFonts,
                  //   null,
                  //   blackBrush,
                  //   pageWidth / 2 - 40,
                  //   currentY
                  // );
                  // const textWidth = boldFonts.measureString(
                  //   invoiceDetails.SellerRemarks
                    
                  // ).width;
                  
                  // graphics.drawString(
                  //   invoiceDetails.SellerRemarks,
                  //   boldFonts,
                  //   null,
                  //   blackBrush,
                  //   pageWidth / 2 - textWidth / 2,  // Changed from: pageWidth / 2 - 40
                  //   currentY
                  // );
                  
                  

const remarks = invoiceDetails.SellerRemarks;

const format = new PdfStringFormat();
format.alignment = PdfTextAlignment.Center;
format.lineAlignment = PdfVerticalAlignment.Top;
format.wordWrap = PdfWordWrapType.Word;

const maxWidth = 350; 

graphics.drawString(
  String(remarks).toUpperCase(),
  boldFonts,
  null,
  blackBrush,
  pageWidth / 2 - maxWidth / 2,
  currentY,
  maxWidth,
  100, // enough height for multiple lines
  format
);

                  currentY += 20;
                
                // ===== Save or Return Blob =====
        if (type === 'save') {
          const pdfBlob = await document.save();
          document.destroy();
          return pdfBlob;
        } else {
          document.save("SalesTaxInvoice.pdf");
          document.destroy();
        }
      }


    }

    export default new SaleInvoiceServicePreivewG();